import styled from 'styled-components';
import { BREAKPOINTS } from 'styles';

export const StyledUserModalWrapper = styled.div`
  ${BREAKPOINTS.laptop} {
    .ant-modal-body {
      padding-right: 16px;
      max-height: 60vh;
      overflow-y: auto;
    }
  }
`;
